import React from 'react';
import { CheckCircle } from 'lucide-react';
import DiaryNoteSection from '../diary/DiaryNoteSection';

const Results = ({ questions, userAnswers, onRetry, instruction, onBack, topic }) => {
  const answeredCount = Object.keys(userAnswers).length;
  const totalCount = questions.length;
  const completionPercentage = Math.round((answeredCount / totalCount) * 100);

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', padding: '40px 20px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
            padding: '40px',
            textAlign: 'center',
            marginBottom: '30px'
          }}
        >
          {/* Success Icon */}
          <div style={{ marginBottom: '30px' }}>
            <CheckCircle size={64} color="#28a745" strokeWidth={1.5} style={{ margin: '0 auto' }} />
          </div>

          {/* Completion Message */}
          <h1 style={{ color: '#1a1a1a', marginBottom: '10px', fontSize: '2rem', fontWeight: '500' }}>
            Výborně!
          </h1>
          <p style={{ color: '#666', fontSize: '1rem', marginBottom: '30px' }}>
            Dokončili jste cvičení mluvení
          </p>

          {/* Statistics */}
          <div
            style={{
              backgroundColor: '#f9f9f9',
              padding: '20px',
              borderRadius: '6px',
              marginBottom: '30px'
            }}
          >
            <div style={{ marginBottom: '16px' }}>
              <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '8px' }}>
                Zodpovězené otázky
              </div>
              <div style={{ fontSize: '2rem', color: '#dc3545', fontWeight: '600' }}>
                {answeredCount} / {totalCount}
              </div>
            </div>

            <div style={{ height: '6px', backgroundColor: '#e9ecef', borderRadius: '3px', overflow: 'hidden' }}>
              <div
                style={{
                  height: '100%',
                  backgroundColor: '#dc3545',
                  width: `${completionPercentage}%`,
                  transition: 'width 0.3s ease'
                }}
              />
            </div>

            <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#666' }}>
              {completionPercentage}% Hotovo
            </div>
          </div>
        </div>

        {/* Questions Summary */}
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
            padding: '30px',
            marginBottom: '30px'
          }}
        >
          <h2 style={{ color: '#1a1a1a', fontSize: '1.5rem', fontWeight: '500', marginBottom: '25px', textAlign: 'center' }}>
            Souhrn odpovědí
          </h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {questions.map((question, index) => {
              const isAnswered = userAnswers[question.id];
              return (
                <div
                  key={question.id}
                  style={{
                    padding: '16px',
                    backgroundColor: isAnswered ? '#e8f5e9' : '#fff3cd',
                    borderRadius: '6px',
                    borderLeft: `3px solid ${isAnswered ? '#28a745' : '#ffc107'}`,
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '15px'
                  }}
                >
                  <div style={{ minWidth: '30px', color: '#007bff', fontWeight: '600', marginTop: '2px' }}>
                    Q{index + 1}:
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: '#333', fontWeight: '500', marginBottom: '8px' }}>
                      {question.question}
                    </div>
                    <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '8px' }}>
                      <strong>Nápověda:</strong> {question.hint}
                    </div>
                    <div style={{
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      color: isAnswered ? '#28a745' : '#ff9800'
                    }}>
                      {isAnswered ? '✓ Zodpovězeno' : '○ Nezodpovězeno'}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <DiaryNoteSection
            topic={topic}
            exerciseType="speaking"
          />
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={onRetry}
            style={{
              padding: '10px 24px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '500',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
          >
            Zkusit znovu
          </button>
          <button
            onClick={onBack}
            style={{
              padding: '10px 24px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '500',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0069d9'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            Zpět na menu
          </button>
        </div>
      </div>
    </div>
  );
};

export default Results;
